module.exports = __webpack_public_path__ + "images/emoji/straight_ruler.6d0fa6bcd30e5d3fbf0a.png";